import {
    type AuctionItemEntity,
    type AuctionListingItemEntity,
    type DirectSaleItemEntity,
    type DirectSaleListingItemEntity,
    type NegotiationPlatformEntity,
    SellingMethod,
} from '~/apiClient';

export type PlatformSellingMethod = Extract<SellingMethod, SellingMethod.Auction | SellingMethod.DirectSale>;

export type AuctionListingItemEntityWithSellingMethod = AuctionListingItemEntity & { sellingMethod: SellingMethod.Auction };

export type DirectSaleListingItemEntityWithSellingMethod = DirectSaleListingItemEntity & { sellingMethod: SellingMethod.DirectSale };

export type SaleListingItemEntity = AuctionListingItemEntityWithSellingMethod | DirectSaleListingItemEntityWithSellingMethod;

export type AuctionItemEntityWithSellingMethod = AuctionItemEntity & { sellingMethod: SellingMethod.Auction };

export type DirectSaleItemEntityWithSellingMethod = DirectSaleItemEntity & { sellingMethod: SellingMethod.DirectSale };

export type SaleItemEntity = AuctionItemEntityWithSellingMethod | DirectSaleItemEntityWithSellingMethod;

export function isAuction(
    sale: SaleItemEntity | SaleListingItemEntity
): sale is AuctionItemEntityWithSellingMethod | AuctionListingItemEntityWithSellingMethod {
    return sale.sellingMethod === SellingMethod.Auction;
}

export function isDirectSale(
    sale: SaleItemEntity | SaleListingItemEntity
): sale is DirectSaleItemEntityWithSellingMethod | DirectSaleListingItemEntityWithSellingMethod {
    return sale.sellingMethod === SellingMethod.DirectSale;
}

export interface AuctionItemEntityWithNegotiation extends Omit<AuctionItemEntityWithSellingMethod, 'negotiation'> {
    negotiation: NegotiationPlatformEntity;
}

export const isAuctionItemEntityWithNegotiation = (auction: AuctionItemEntityWithSellingMethod): auction is AuctionItemEntityWithNegotiation =>
    auction.negotiation !== null;
